import React from 'react'
import { Helmet } from 'react-helmet';
import IntroAboutUs from '../../components/intro_about_us/IntroAboutUs'
import Header4 from '../../components/header/header4/Header4';
import VisionMissionAbout from '../../components/vision_mission_about_us/VisionMissionAbout'
import OurServicesAbout from '../../components/our_services_about_us/OurServicesAbout'
import WhyChooseUsAbout from '../../components/why_choose_us_about/WhyChooseUsAbout'
import OurTeamabout from '../../components/our_team_about_us/OurTeamabout'
import OurApproachAbout from '../../components/our_approach_about/OurApproachAbout';
import Footer from '../../components/footer/Footer';
import NewHeroAbout from '../../components/new_hero_about/NewHeroAbout';
import WhatsappCallBtn from '../../components/whatsapp_call_btn/WhatsappCallBtn';
export default function About() {
  return (
    <>
      <Helmet>
        <title>About Us | SARS India Liaison Pvt. Ltd. – Industrial Statutory Compliance & Consulting Experts</title>

        <meta
          name="description"
          content="Learn about SARS India Liaison Pvt. Ltd., an ISO-certified industrial statutory consulting company specializing in PESO, environmental clearance, fire licensing, and compliance solutions across India."
        />

        <meta
          name="keywords"
          content="About Sars India, SARS India Liaison Pvt. Ltd.,sars india, industrial compliance experts, ISO-certified consultants, statutory consulting firm, PESO, EC, CTO, CTE, CGWA, fire NOC, biomedical waste authorization, regulatory approvals India"
        />

        <meta name="author" content="Sars India Liaison Pvt. Ltd." />

        <link rel="canonical" href="https://www.sarsindialiaison.com/about" />
      </Helmet>


      <Header4 />
      <NewHeroAbout />
      <IntroAboutUs />
      <OurTeamabout />
      <VisionMissionAbout />
      <OurServicesAbout />
      <WhyChooseUsAbout />
      <OurApproachAbout />
      <WhatsappCallBtn />
      <Footer />

    </>
  )
}
